// Modul-Karten im Chat: Urs bietet mit dem Tool open_module eine klickbare
// Karte an, die das passende Modul öffnet (optional mit Projekt-Vorauswahl).
// Bewusst kein automatischer Seitenwechsel — die Nutzerin klickt selbst.
// Backend: server/services/tools/ui-tools.js → metadata.moduleCards

import { openModuleFromProject, gotoProjekt } from '../lib/moduleLink.js'

function openCard(card) {
  // Projektseite hat eine eigene Route (projektzentrierte Navigation)
  if (card.page === 'projects' && card.project_id) {
    gotoProjekt(card.project_id)
    return
  }
  if (card.preselect && card.project_id) {
    openModuleFromProject(card.page, {
      id: card.project_id,
      name: card.project_name,
      project_number: card.project_number,
    })
    return
  }
  window.location.hash = '#/' + card.page
}

export default function ModuleCards({ cards }) {
  if (!cards?.length) return null
  return (
    <div className="chat-email-cards">
      {cards.map((card, i) => {
        const projektLabel = [card.project_number, card.project_name].filter(Boolean).join(' ')
        const sub = card.hinweis || projektLabel
        return (
          <div
            key={`${card.page}-${i}`}
            className="chat-email-card"
            onClick={() => openCard(card)}
            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openCard(card) } }}
            role="button"
            tabIndex={0}
            title={`${card.label} öffnen`}
          >
            <div className="chat-email-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <path d="M3 9h18M9 21V9" />
              </svg>
            </div>
            <div className="chat-email-info">
              <span className="chat-email-sender">{card.label}</span>
              {sub && <span className="chat-email-subject">{sub}</span>}
            </div>
            <div className="chat-email-arrow">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M7 17L17 7M8 7h9v9" />
              </svg>
            </div>
          </div>
        )
      })}
    </div>
  )
}
